import React, { useEffect } from "react";
import {
    stileInterface,
    sendStileEventCall,
} from "../../../javascript/stileInterface";
import isVRReady from "../../../javascript/isVRReady";

// Detect Safari browser
export const isSafari =
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent) &&
    !/Chromium/.test(navigator.userAgent);

// Calculate fixed dimensions once on load
const fixedDimensions = {
    width: window.innerWidth,
    height: Math.round(window.innerWidth * 0.5625), // 16:9 aspect ratio
};

// Override getWindowDimensions to always return the same fixed dimensions.
// This prevents Safari's resize loop where the iframe and widget continuously
// resize each other.
stileInterface.getWindowDimensions = function (callback) {
    callback(null, fixedDimensions);
};

// Fullwindow wrapper style for mobile/VR devices
const fullwindowWrapperStyle = {
    width: "100%",
    height: "100%",
    position: "fixed",
};

// Standard wrapper style using fixed pixels to match getWindowDimensions
const standardWrapperStyle = {
    position: "relative",
    backgroundColor: "#eee",
    overflow: "hidden",
    margin: "0 auto",
    width: `${fixedDimensions.width}px`,
    height: `${fixedDimensions.height}px`,
};

// Wrapper component that supports both standard and fullwindow modes
export const VRWrapper = ({ children, isFullwindow }) => {
    const useFullwindow =
        isFullwindow !== undefined ? isFullwindow : isVRReady();

    const wrapperStyle = useFullwindow
        ? fullwindowWrapperStyle
        : standardWrapperStyle;

    // Notify Stile once on mount
    useEffect(() => {
        try {
            sendStileEventCall("changeWindowDimensions");
        } catch (e) {
            console.log(e);
        }
    }, []);

    return (
        <div id="wrapper" style={wrapperStyle}>
            {children}
        </div>
    );
};

// Call this before ReactDOM.render to notify Stile once on Safari
export const notifyStileOnSafari = () => {
    if (isSafari) {
        try {
            sendStileEventCall("changeWindowDimensions");
        } catch (e) {
            console.log(e);
        }
    }
};
